module.exports = __webpack_public_path__ + "static/media/coliseu_box_11.992e46d7.jpg";